module.exports = __webpack_public_path__ + "static/media/image-4@3x.bc3df9e7.png";